export class AgeVerificationError extends Error {
  constructor() {
    super('You must confirm that you are over 18 to continue.');

    this.name = 'AgeVerificationError';
  }
}
